import { aspenApi as api, getVentureDetail } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IReqVentureDetail, IRes } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取venture产品详情。
 * @param {IReqVentureDetail} params - 获取venture产品详情所需的参数。
 */
export const useFetchVentureDetail = (params: IReqVentureDetail) => {
  const apiPath = api.ventures.ventureDetail;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<IRes>(queryKey);

  const { error, data, isLoading, refetch, isFetching, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return getVentureDetail(params).then(res => {
        return res;
      });
    },
    placeholderData: cacheData,
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading, isFetching };
};
